import React from 'react';
import clsx from 'clsx';

/**
 * How much of a known amount of work is done.
 *
 * Without a total there is nothing to divide by, and a bar stuck at zero reads
 * as broken, so the caller decides whether to show it at all.
 *
 * @param {object} props
 * @param {number} props.value
 * @param {number} props.max
 * @param {string} [props.label] - Shown under the bar, e.g. "12 de 40".
 * @param {'sm'|'md'} [props.size='md']
 * @param {string} [props.testId]
 */
export const ProgressBar = ({ value, max, label, size = 'md', testId }) => {
  const percentage = max > 0 ? Math.min(100, Math.round((value / max) * 100)) : 0;

  return (
    <div className="space-y-1.5" data-testid={testId}>
      <div
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={max}
        aria-valuenow={value}
        aria-label={label}
        className={clsx(
          'rounded-full bg-ninja-gray dark:bg-[#2d2d2d] overflow-hidden',
          size === 'sm' ? 'h-1.5' : 'h-2'
        )}
      >
        <div
          className="h-full bg-ninja-green transition-all duration-500"
          style={{ width: `${percentage}%` }}
        />
      </div>
      {label && <p className="text-xs text-text-muted">{label}</p>}
    </div>
  );
};
